import { useEffect } from "react";
import Lenis from "lenis";

const prefersReduced = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export function useLenis() {
  useEffect(() => {
    if (prefersReduced()) {
      document.documentElement.classList.add("reduce-motion");
      return;
    }
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    // anchor links -> smooth scroll
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -90 });
        }
      }
    };
    document.addEventListener("click", onClick);
    window.__lenis = lenis;

    // Handle hash on initial mount (e.g. navigation from subpage to /#contact)
    if (window.location.hash && window.location.hash.length > 1) {
      setTimeout(() => {
        try {
          const target = document.querySelector(window.location.hash);
          if (target) lenis.scrollTo(target, { offset: -90 });
        } catch (_) {}
      }, 300);
    }
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
}

export const REDUCED = prefersReduced;
